// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { actions as jwtActions } from 'nozzmo-redux-jwt';
import {
  MdLock,
  MdEmail,
} from 'react-icons/lib/md';

import * as selectors from '../../reducers';
import Button from '../Button';
import {
  RenderInput,
} from '../FieldRenderer';


const triggerLogin = (
  values,
  dispatch,
) => dispatch(jwtActions.startLogin(values.username, values.password));

const validate = (values) => {
  const errors = {};

  if (!values.username) { errors.username = 'Requerido'; }
  if (!values.password) { errors.password = 'Requerido'; }

  return errors;
};

type LofinFormPropTypes = {
  handleSubmit: Function,
  isLoading?: boolean,
};

const LoginForm = ({
  handleSubmit,
  isLoading = false,
}: LofinFormPropTypes) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="username"
      placeholder="Email"
      props={{ Icon: MdEmail }}
      component={RenderInput}
    />
    <Field
      type="password"
      name="password"
      placeholder="Contraseña"
      props={{ Icon: MdLock }}
      component={RenderInput}
    />
    <Button
      isLoading={isLoading}
      title="Ingresar"
      isFullWidth
      type="submit"
    />
  </form>
);


export default connect(
  state => ({
    isLoading: selectors.isLoginLoading(state),
  }),
  undefined,
)(reduxForm({
  form: 'loginForm',
  onSubmit: triggerLogin,
  validate,
})(LoginForm));

/*
import {
  RenderTaggedInput,
} from '../FieldRenderer';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults';
import OmnisearchResult from '../OmnisearchResult';

<Field
  name="tags"
  fetchItems={}
  renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
  renderItem={
    (item, isHighlighted) => (
      <OmnisearchResult
        {...item}
        key={item.value}
        isSelected={isHighlighted}
        size="small"
      />
    )
  }
  inputProps={{ isClearContained: true }}
  size="small"
  component={RenderTaggedInput}
/>

*/



// WEBPACK FOOTER //
// ./src/scripts/components/LoginForm/index.jsx